import type { Product } from '../../types'
import { unitLabels } from '../../lib/catalogConfig'
import { useCategoryStore } from '../../store/categoryStore'

interface Props {
  product: Product
}

export default function ProductInfoTable({ product }: Props) {
  const { categories } = useCategoryStore()
  const categoryName = product.category_id 
    ? categories.find(c => c.id === product.category_id)?.name ?? '—'
    : '—'
  return (
    <div className="rounded-[14px] overflow-hidden border border-cream-dark mb-7">
      {[
        { label: 'מחיר',        value: `₪${product.price} / ${unitLabels[product.unit]}` },
        { label: 'כמות זמינה', value: `${product.quantity} ${unitLabels[product.unit]}` },
        { label: 'קטגוריה', value: categoryName },
        ...(product.custom_sku || product.sku ? [{ label: 'מק״ט', value: `${product.custom_sku ?? product.sku}` }] : []),
      ].map((row, i) => (
        <div
          key={row.label}
          className={`flex justify-between items-center px-5 py-3.5 ${i % 2 === 0 ? 'bg-cream' : 'bg-white'}`}
        >
          <span className="text-[15px] font-semibold text-text-primary">{row.value}</span>
          <span className="text-sm text-text-muted">{row.label}</span>
        </div>
      ))}
    </div>
  )
}